import React from "react";

function Guideline(props) {
  return (
    <p className="guidelines" id={props.id + "_g"}>
      <small>{props.children}</small>
    </p>
  );
}

export default Guideline;
